import * as Immutable from "immutable";
import { DataCorrectionRequestFormFields } from './DataCorrectionRequestForm';
import { DcfRequest, Subject, Site, Visit, QueryOfVisit, QueryOfSession, Session, QueryOfSubject } from "webportalclient";

export interface DcfRecordState<T> {
    query: T;
    isLoading: boolean;
}

export interface Correction {
    sourceCorrection: VisibleWizard;
    correctionTypeId: string;
    entity: string;
    field: string;
    oldValue: any;
    newValue: any;
}

export interface MiscCorrection {
    fromDetails: string;
    toDetails: string;
}

export interface VisibleWizardFor {
    recordId: string;
    fieldValue: any;
    wizard: VisibleWizard;
}

export enum VisibleWizards {
    SessionSuppress = "sessionSuppress",
    SubjectType = "subjectType",
    Misc = "misc",
    SubjectNumber = "subjectNumber",
    RecordingStart = "recordingStart",
    MediaSerial = "mediaSerial",
    EntityLabels = "entityLabels",
    SwapLabels = "swapLabels"
}

export type VisibleWizard = null | VisibleWizards.RecordingStart | VisibleWizards.SubjectNumber | VisibleWizards.SubjectType | VisibleWizards.Misc | VisibleWizards.SessionSuppress | VisibleWizards.MediaSerial | VisibleWizards.EntityLabels | VisibleWizards.SwapLabels;

export const correctionTypeIdToWizard: Record<string, VisibleWizard> = {
    CR_SESSION_SUPPRESS: VisibleWizards.SessionSuppress,
    CR_SUBJECT_TYPE: VisibleWizards.SubjectType,
    CR_MISCELLANEOUS: VisibleWizards.Misc,
    CR_SUBJECT_NUMBER: VisibleWizards.SubjectNumber,
    CR_RECORDING_START: VisibleWizards.RecordingStart,
    CR_MEDIA_SERIAL: VisibleWizards.MediaSerial,
    CR_MOVE_SESSION: VisibleWizards.EntityLabels,
    CR_SWAP_LABELS: VisibleWizards.SwapLabels
};

export interface DcfRequestState {
    errorMessage: string;
    failedSavingAttachment?: boolean;
    isSubmitting: boolean;
    principalInvestigator: string;
    savedRequests: Array<DcfRequest>;
    records: Array<string>;
    subjectOptionsQuery: QueryOfSubject;
    visitOptionsQueries: Immutable.Map<string, DcfRecordState<QueryOfVisit>>;
    sessionOptionsQueries: Immutable.Map<string, DcfRecordState<QueryOfSession>>;
    selectedSubjects: Immutable.Map<string, Subject>;
    selectedVisits: Immutable.Map<string, Visit>;
    selectedSessions: Immutable.Map<string, Session>;
    isAuditModalVisible: boolean;
    isLoadingSubjectOptions: boolean;
    isLoadingVisits: boolean;
    isLoadingSessions: boolean;
    corrections: Immutable.Map<string, Array<Correction>>;
    miscCorrection: Immutable.Map<string, MiscCorrection>;
    visibleWizard: VisibleWizardFor;
    formHydration: DataCorrectionRequestFormFields;
    siteId: string;
    editCorrections: Array<Correction>;
}

export const defaultRecordId = new Date().getTime().toString();

export const initialDcfRequestState = {
    errorMessage: null,
    failedSavingAttachment: false,
    isSubmitting: false,
    principalInvestigator: "",
    savedRequests: [],
    records: [defaultRecordId],
    subjectOptionsQuery: {
        value: [],
    },
    visitOptionsQueries: Immutable.Map([
        [
            defaultRecordId,
            {
            query: {
                value: [],
            },
            isLoading: false
        }]
        ]),
    sessionOptionsQueries: Immutable.Map([
        [
            defaultRecordId,
            {
                query: {
                    value: [],
                },
                isLoading: false
            }
        ]
    ]),
    selectedSubjects: Immutable.Map([
        [
            defaultRecordId,
            null,
        ]
    ]),
    selectedVisits: Immutable.Map([
        [
            defaultRecordId,
            null,
        ]
    ]),
    selectedSessions: Immutable.Map([
        [
            defaultRecordId,
            null
        ]
    ]),
    isAuditModalVisible: false,
    isLoadingSubjectOptions: false,
    isLoadingVisits: false,
    isLoadingSessions: false,
    corrections: Immutable.Map([
        [
            defaultRecordId,
            []
        ]
    ]),
    miscCorrection: Immutable.Map([
        [
            defaultRecordId,
            null
        ]
    ]),
    visibleWizard: {
        recordId: null,
        wizard: null,
        fieldValue: null,
    },
    formHydration: undefined,
    siteId: undefined,
} as DcfRequestState;
